import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import adminSurveyService from '../services/adminSurveyService';
import ReactMarkdown from 'react-markdown';

const AdminChatAnalytics = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [chats, setChats] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fn_getChat();
    }, []);

    const fn_getChat = async () => {
        try {
            setIsLoading(true);
            const response = await adminSurveyService.getAllAdminChatMessages(id);
            setChats(response?.data || []);
        } catch (error) {
            console.error('Error fetching chat data:', error);
            setChats([]);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <div className="min-h-screen bg-white">
                <div className="bg-white border-b border-gray-200 px-4 py-4 flex items-center justify-between">
                    <div className="flex items-center">
                        <button
                            onClick={() => navigate(-1)}
                            className="text-gray-600 hover:text-gray-900 flex items-center mr-4"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M19 12H5M12 19l-7-7 7-7" />
                            </svg>
                            <span className="ml-1">Analytics</span>
                        </button>
                    </div>
                    <h1 className="text-xl font-semibold">DingAI Chat</h1>
                    <div className="w-24"></div>
                </div>

                <div className="max-w-4xl mx-auto p-4">
                    <div className="animate-pulse space-y-6">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <div key={i} className="flex justify-start">
                                <div className="flex flex-col max-w-3xl">
                                    <div className="flex items-center mb-2">
                                        <div className="bg-gray-200 rounded-full w-8 h-8 mr-2"></div>
                                        <div className="h-4 bg-gray-200 rounded w-16"></div>
                                    </div>
                                    <div className="bg-gray-100 rounded-2xl p-4">
                                        <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
                                        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 px-4 py-4 flex items-center justify-between">
                <div className="flex items-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="text-gray-600 hover:text-gray-900 flex items-center mr-4"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M19 12H5M12 19l-7-7 7-7" />
                        </svg>
                        <span className="ml-1">Analytics</span>
                    </button>
                </div>
                <h1 className="text-xl font-semibold">DingAI Chat</h1>
                <div className="w-24"></div> {/* For balancing the header */}
            </div>

            {/* Chat messages */}
            <div className="max-w-4xl mx-auto p-4">
                {chats?.length > 0 ? chats?.map((message, index) => (
                    <div
                        key={index}
                        className={`mb-6 flex ${message?.from === 'User' ? 'justify-end' : 'justify-start'}`}
                    >
                        {message?.from === 'Admin' && (
                            <div className="flex flex-col max-w-3xl">
                                <div className="flex items-center mb-2">
                                    <div className="bg-[#2962FF] text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                                        AI
                                    </div>
                                    <span className="font-medium">DingAI</span>
                                </div>
                                <div className="bg-white border border-gray-200 rounded-2xl p-4 shadow-sm">
                                    <p className="text-gray-800"><ReactMarkdown>{message?.message}</ReactMarkdown></p>
                                </div>
                            </div>
                        )}

                        {message?.from === "User" && (
                            <div className="flex flex-col items-end max-w-3xl">
                                <div className="bg-[#2962FF] text-white rounded-2xl p-4 shadow-sm">
                                    <p className="text-white">{message?.message}</p>
                                </div>
                            </div>
                        )}
                    </div>
                )) : (
                    <div className="text-center py-12">
                        <div className="text-gray-400 text-lg mb-2">No chat messages found</div>
                        <p className="text-gray-500">This conversation appears to be empty.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminChatAnalytics;
